import { SelectionCustomCargoParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/components/RoutesCalculationWidget/CargoSelection/types';
import { CargoType } from '@pages/AdditionalServices/tabs/DeliveryForm/components/RoutesCalculationWidget/interfaces';
import {
  ContainerParameters,
  CustomCargoParameters,
  TransportLoad,
  TruckParameters,
} from '@services/requests/orderService/types';
import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

export interface TransportCountByType {
  weight: number;
  transportTypeId: number;
}

interface CountByType {
  count: number;
  transportTypeId: number;
}

export interface MultiConversionCargo {
  cargoFingerprint: string;
  containerCountByType: CountByType[];
  containerLoads: TransportLoad[];
  truckCountByType: CountByType[];
  truckLoads: TransportLoad[];
}

export interface ConversionCargo {
  cargoType: string;
  containerParameters: ContainerParameters[];
  truckParameters: TruckParameters[];
  multiParam: MultiConversionCargo[];
}

export interface SelectCargoParametersQueryResponse {
  data: {
    customCargoParameters: CustomCargoParameters[];
    conversationCargos: ConversionCargo | null;
    errorMsg: string;
  };
}

// Запрос подбора параметров груза
export class SelectCargoParametersQuery implements GraphQLQuery<null> {
  readonly query: any;

  readonly variables: null;

  constructor(params: SelectionCustomCargoParameters[], cargoType: CargoType) {
    this.variables = null;

    const customCargoParameters: string[] = params.map((cargo) => {
      const type =
        cargo.parametersCargoCalcType === 'base'
          ? cargo.customCargoType
          : cargo.parametersCargoCalcType;
      return `{
              customCargoType: ${type},
              baseParameters: {
                quantity: ${cargo.baseParameters.quantity},
                length: ${cargo.baseParameters.length},
                width: ${cargo.baseParameters.width},
                height: ${cargo.baseParameters.height},
                weight: ${cargo.baseParameters.weight}
              },
              palletParameters:{
                type: ${cargo.palletParameters.type}
                quantity: ${cargo.palletParameters.quantity}
                normativeHeightOfStacking: ${cargo.palletParameters.normativeHeightOfStacking}
                weight: ${cargo.palletParameters.weight}
              },
              volumeParameters:{
                volume: ${cargo.volumeParameters.volume}
                weight: ${cargo.volumeParameters.weight}
              }
            }`;
    });

    const cargoTypeDependencies = {
      container: 'container',
      auto: 'truck',
      fclFtl: 'multiTransport',
    };

    const toCargoType = cargoTypeDependencies[cargoType] ?? 'default';

    const parametersQuery = `
	  toCargoType: ${toCargoType}, 
	  customCargoParameters: [
        ${customCargoParameters.join(',')}
      ],
    `;

    this.query = gql`
      query __SELECT_CARGO_PARAMETERS__ {
        data: cargoConverter(
          ${parametersQuery}
        ) {
		  errorMsg
          customCargoParameters {
			customCargoType
			baseParameters {
				quantity
				length
				width
				height
				weight
			}
			palletParameters {
				type
				quantity
				normativeHeightOfStacking
				weight
			}
			volumeParameters {
				volume
				weight
			}
		  }
		  conversationCargos {
			cargoType
			containerParameters {
              containerId
              eachContainerWeight
              containerQuantity
			  withPallets
			  palletsLoaded {
			  	quantity
				type
				weight
			  }
            }
			truckParameters {
              truckId
              eachTruckWeight
              truckQuantity
			  withPallets
			  palletsLoaded {
			  	quantity
				type
				weight
			  }
            }
			multiParam {
			  cargoFingerprint
			  containerCountByType {
				count
				transportTypeId
			  }
			  truckCountByType {
				count
				transportTypeId
			  }
			  containerLoads {
				usedWeight
				usedVolume
				transportTypeId
				usedPallets {
					count
					palletType
				}
				items {
					cargoItemId
					isPallet
					palletType
					volume
					weight
				}
			  }
			  truckLoads {
				usedWeight
				usedVolume
				transportTypeId
				usedPallets {
					count
					palletType
				}
				items {
					cargoItemId
					isPallet
					palletType
					volume
					weight
				}
			  }
			}
		  }
        }
      }
    `;
  }
}
